/*
  li-dtf.js (Lucky Inger, 2026-11-02)
  DTF / digital print order page. Pairs with sections/li-dtf-order.liquid,
  snippets/li-dtf-product.liquid and assets/li-dtf.css.

  The page holds a client's whole DTF range: every DTF product in the same
  client collection is a garment button. Sizes are entered per design,
  colour (and full zip for hoodies), on a colour x size grid on desktop and
  colour cards with steppers on phones.

  Cart format (unchanged, so the cart page and the order Worker read it as
  before): one cart line per garment product, quantity = total units, with
  Print method, "Line N - Design - Colour[ - Full Zip]", Tier, _tier_table,
  Total units, Order total, Grand total, _preview_image and _dtf_payload.

  The page always shows what's already in the cart for these garments, so
  "Add" replaces those lines instead of stacking new ones, and the cart's
  Edit link just opens this page.

  Prices: price records (li_pricing_group dtf-apparel, li_garment surcharges,
  li_order_option full-zip), passed in by the section. All DTF garments in
  the cart count together toward the price break.
*/
(function () {
  'use strict';
  if (window.__liDtf) return;
  window.__liDtf = true;

  /* ── Constants ───────────────────────────────────────────────────────────────── */
  var ADULT = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6/7XL', '8/9XL', '10/11XL'];
  var KIDS = ['K2', 'K4', 'K6', 'K8', 'K10', 'K12', 'K14', 'K16'];
  var REC = { atee: 'adult_tee', ahood: 'adult_hood', asweat: 'adult_sweat', asinglet: 'adult_singlet', atank: 'adult_tank', ktee: 'kids_tee', khood: 'kids_hood', ksweat: 'kids_sweat' };
  var LABEL = { atee: 'Adult Tee', ahood: 'Adult Hood', asweat: 'Adult Sweater', asinglet: 'Adult Singlet', atank: 'Adult Tank', ktee: 'Kids Tee', khood: 'Kids Hood', ksweat: 'Kids Sweater' };
  var SHORT = { atee: 'Tee', ahood: 'Hoodie', asweat: 'Sweater', asinglet: 'Singlet', atank: 'Tank', ktee: 'Kids tee', khood: 'Kids hoodie', ksweat: 'Kids sweater' };
  var KIDS_G = { ktee: 1, khood: 1, ksweat: 1 };
  var ZIP_G = { ahood: 1, asweat: 1 };
  var SPLIT = [['S', 10], ['M', 20], ['L', 30], ['XL', 25], ['2XL', 10], ['3XL', 5]];
  var KSPLIT = [['K4', 10], ['K6', 15], ['K8', 20], ['K10', 20], ['K12', 20], ['K14', 15]];
  var HEX = {
    black: '#111111', white: '#f4f4f2', navy: '#1f2a44', 'grey marle': '#9b9b9b', grey: '#8a8a8a', gray: '#8a8a8a',
    'hot pink': '#e0529c', pink: '#f2a5c4', 'kelly green': '#2e9b4f', sage: '#9caf88', 'pea green': '#9cbf5b',
    army: '#4b5320', ecru: '#e8dfc8', cypress: '#556b55', walnut: '#5d4636', sand: '#d8c7a3', cobalt: '#2350b5',
    sapphire: '#1b4f9c', fog: '#c9ccc8', orange: '#f07c2a', red: '#c8302c', royal: '#2c4fc4', bone: '#e6dccb',
    butter: '#f3e3a1', clay: '#b4775c', powder: '#b8cde3', charcoal: '#3a3a3a', maroon: '#6b1f2b', green: '#2f7d47'
  };

  /* ── Small helpers ─────────────────────────────────────────────────────── */
  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function int(v) { var n = parseInt(String(v == null ? '' : v).replace(/[^0-9]/g, ''), 10); return isFinite(n) ? n : 0; }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.\-]/g, '')); return isFinite(n) ? n : 0; }
  function cents(n) { return Math.round(n * 100); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function moneyC(n) { return '$' + (Math.round(n * 100) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function json(s, fb) { try { var v = JSON.parse(s); return v == null ? fb : v; } catch (e) { return fb; } }
  function lc(s) { return String(s || '').toLowerCase().trim(); }
  function isBlack(c) { return !c || /black/i.test(c); }
  function sizeKey(label) { return String(label).toLowerCase().replace(/\//g, '-'); }
  function sizeLabelFromKey(k) { return String(k || '').toUpperCase().replace(/^(\d+)-(\d+)XL$/, '$1/$2XL'); }
  function normSize(v, kids) {
    var s = String(v == null ? '' : v).toUpperCase().replace(/\s+/g, '');
    var map = { SMALL: 'S', MEDIUM: 'M', LARGE: 'L', 'X-LARGE': 'XL', XLARGE: 'XL', 'XX-LARGE': '2XL', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL', 'X-SMALL': 'XS', XSMALL: 'XS' };
    if (map[s]) s = map[s];
    s = s.replace(/^(\d+)[-\/](\d+)XL$/, '$1/$2XL');
    if (kids || /^K?\d{1,2}$/.test(s)) { var m = s.match(/^K?(\d{1,2})$/); if (m) return 'K' + m[1]; }
    return s;
  }
  function swatch(c) {
    var h = HEX[lc(c)];
    if (!h) { Object.keys(HEX).some(function (k) { if (lc(c).indexOf(k) >= 0) { h = HEX[k]; return true; } return false; }); }
    return h || '#777777';
  }
  function byName(a, b) { return String(a).localeCompare(String(b), 'en', { numeric: true, sensitivity: 'base' }); }
  function byColour(a, b) { var x = isBlack(a), y = isBlack(b); return x === y ? byName(a, b) : (x ? -1 : 1); }
  var GORDER = ['atee', 'ahood', 'asweat', 'asinglet', 'atank', 'ktee', 'khood', 'ksweat'];
  /* Same design on another garment, allowing small spelling differences ("OG TRUCK" / "TRUCK") */
  function fitName(list, name, fallback) {
    var l = lc(name), hit = null;
    list.forEach(function (x) { if (hit === null && lc(x) === l) hit = x; });
    if (hit === null && l) list.forEach(function (x) { if (hit === null && x && (l.indexOf(lc(x)) >= 0 || lc(x).indexOf(l) >= 0)) hit = x; });
    return hit !== null ? hit : fallback;
  }
  function uniq(a) { var o = []; (a || []).forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; }
  function sumObj(o) { var t = 0; Object.keys(o || {}).forEach(function (k) { t += int(o[k]); }); return t; }
  function readCart(r) {
    if (window.liReadCartJson) return window.liReadCartJson(r);
    return r.text().then(function (t) {
      var d = {}; try { d = t ? JSON.parse(t) : {}; } catch (e) { d = { description: t }; }
      if (r.status >= 400 || d.status === 422 || (typeof d.status === 'number' && d.status >= 400) || d.message === 'Cart Error') {
        throw new Error(d.description || d.message || ('Cart error (' + r.status + ')'));
      }
      return d;
    });
  }

  /* ── State ─────────────────────────────────────────────────────────────── */
  var root, data, P = [], byId = {}, TIERS = [], GARM = {}, ZIP = 7.7, MIN = 25;
  var S = {
    cur: null,            // product id on screen
    design: {},           // product id -> selected design
    q: {},                // Q[pid][design][rowKey][sizeLabel] = qty
    open: {},             // phone: open row per product+design
    main: null,           // gallery image override
    otherUnits: 0,        // DTF pieces in the cart from products not on this page
    cartKeys: {},         // pid -> [cart line keys]
    baseline: '',         // Q as loaded from the cart
    busy: false,
    msg: '', msgKind: '',
    desktop: false,
    zipMode: {},          // product id -> showing the full zip sizes
    undo: null
  };
  var DRAFT_KEY = '';

  /* ── Product model ─────────────────────────────────────────────────────── */
  function buildProduct(raw) {
    var g = REC[raw.garment] ? raw.garment : 'atee';
    var kids = !!KIDS_G[g];
    var rec = GARM[REC[g]] || null;
    var base = rec && rec.sizes && rec.sizes.length ? rec.sizes.map(function (x) { return normSize(x, kids); }) : (kids ? KIDS : ADULT);
    var opt = raw.opts || {};
    var optSizes = (opt.size || []).map(function (x) { return normSize(x, kids); });
    var sizes = optSizes.length ? base.filter(function (s) { return optSizes.indexOf(s) >= 0; }) : base.slice();
    if (!sizes.length) sizes = base.slice();
    var designs = uniq(opt.design || []);
    if (!designs.length) designs = [''];
    var colours = uniq(opt.colour || []).sort(byColour);
    if (!colours.length) colours = [''];
    var styles = uniq(opt.style || []);
    var zipStyle = null, plainStyle = null;
    styles.forEach(function (s) { if (/zip/i.test(s)) { if (!zipStyle) zipStyle = s; } else if (!plainStyle) plainStyle = s; });
    var combos = (raw.combos || []).filter(Boolean);
    // Newest design first: new variants are added at the end of the product, so a
    // design that first shows up later in the variant list is newer.
    var firstAt = {};
    combos.forEach(function (c, i) { if (firstAt[c[0]] == null) firstAt[c[0]] = i; });
    designs.sort(function (a, b) { return ((firstAt[b] || 0) - (firstAt[a] || 0)) || byName(a, b); });
    var img = {}, designImg = {};
    combos.forEach(function (c) {
      if (!c[3]) return;
      var k = c[0] + '~' + c[1];
      if (!img[k] || (!/zip/i.test(c[2]) && img[k].zip)) img[k] = { url: c[3], zip: /zip/i.test(c[2]) };
      if (!designImg[c[0]] || (isBlack(c[1]) && !designImg[c[0]].black)) designImg[c[0]] = { url: c[3], black: isBlack(c[1]) };
    });
    var imgs = (raw.imgs || []).filter(Boolean);
    var surch = {};
    if (rec && rec.surcharges) Object.keys(rec.surcharges).forEach(function (k) { surch[normSize(k, kids)] = num(rec.surcharges[k]); });
    var capIdx = -1;
    if (rec && rec.colourMax && !kids) capIdx = sizes.indexOf(normSize(rec.colourMax, kids));
    var rows = colours.map(function (c) { return { key: c, colour: c, zip: false, label: c || 'Black' }; });
    if (ZIP_G[g]) {
      var blk = null; colours.forEach(function (c) { if (!blk && isBlack(c)) blk = c; });
      if (blk !== null) rows.push({ key: blk + '|zip', colour: blk, zip: true, label: blk || 'Black' });
    }
    return {
      id: raw.id, title: raw.title, url: raw.url, variantId: raw.variantId, template: raw.template,
      g: g, kids: kids, rec: rec, sizes: sizes, designs: designs, colours: colours, styles: styles,
      zipStyle: zipStyle, plainStyle: plainStyle, rows: rows, img: img, designImg: designImg, imgs: imgs,
      surch: surch, capIdx: capIdx, label: LABEL[g], short: SHORT[g]
    };
  }
  function rowFor(p, key) { for (var i = 0; i < p.rows.length; i++) if (p.rows[i].key === key) return p.rows[i]; return null; }
  /* Hoodies and sweaters: Pullover / Full zip switch above the sizes. The zip
     sizes are their own row (key "Black|zip"), shown only in Full zip mode. */
  function hasZip(p) { return p.rows.some(function (r) { return r.zip; }); }
  function visRows(p) {
    if (!hasZip(p)) return p.rows;
    var z = !!S.zipMode[p.id];
    return p.rows.filter(function (r) { return !!r.zip === z; });
  }
  function zipUnits(p, d, zip) {
    var t = 0; p.rows.forEach(function (r) { if (!!r.zip === zip) t += rowUnits(p.id, d, r.key); }); return t;
  }
  function sizeOk(p, row, size) {
    var i = p.sizes.indexOf(size);
    if (i < 0) return false;
    if (row.zip && !isBlack(row.colour)) return false;
    if (!isBlack(row.colour) && p.capIdx >= 0 && i > p.capIdx) return false;
    return true;
  }
  function ensureDesign(p, d) { if (p.designs.indexOf(d) < 0) p.designs.push(d); }
  function ensureRow(p, colour, zip) {
    var key = colour + (zip ? '|zip' : '');
    if (rowFor(p, key)) return key;
    if (p.colours.indexOf(colour) < 0) p.colours.push(colour);
    p.rows.push({ key: key, colour: colour, zip: !!zip, label: colour || 'Black' });
    return key;
  }

  /* ── Quantities ────────────────────────────────────────────────────────── */
  function cell(pid, d, rk) {
    var a = S.q[pid] || (S.q[pid] = {});
    var b = a[d] || (a[d] = {});
    return b[rk] || (b[rk] = {});
  }
  function getQ(pid, d, rk, s) { var a = S.q[pid]; if (!a || !a[d] || !a[d][rk]) return 0; return int(a[d][rk][s]); }
  function setQ(pid, d, rk, s, v) {
    v = Math.max(0, Math.min(99999, int(v)));
    var c = cell(pid, d, rk);
    if (v) c[s] = v; else delete c[s];
  }
  function rowUnits(pid, d, rk) { var a = S.q[pid]; return a && a[d] && a[d][rk] ? sumObj(a[d][rk]) : 0; }
  function designUnits(pid, d) { var a = S.q[pid], t = 0; if (!a || !a[d]) return 0; Object.keys(a[d]).forEach(function (rk) { t += sumObj(a[d][rk]); }); return t; }
  function productUnits(pid) { var a = S.q[pid], t = 0; if (!a) return 0; Object.keys(a).forEach(function (d) { t += designUnits(pid, d); }); return t; }
  function pageUnits() { var t = 0; P.forEach(function (p) { t += productUnits(p.id); }); return t; }
  function qSig() {
    var out = {};
    P.forEach(function (p) {
      var a = S.q[p.id]; if (!a) return;
      Object.keys(a).sort().forEach(function (d) {
        Object.keys(a[d]).sort().forEach(function (rk) {
          Object.keys(a[d][rk]).sort().forEach(function (s) { var v = int(a[d][rk][s]); if (v) out[p.id + '|' + d + '|' + rk + '|' + s] = v; });
        });
      });
    });
    return JSON.stringify(out);
  }
  function snapshot() { return JSON.stringify(S.q); }
  function restore(snap) { S.q = json(snap, {}); }

  /* ── Pricing ─────────────────────────────────────────────────────────────── */
  function tierAt(units) {
    if (!TIERS.length) return null;
    var pick = TIERS[0];
    TIERS.forEach(function (t) { if (units >= t.min) pick = t; });
    return pick;
  }
  function nextTier(units) { for (var i = 0; i < TIERS.length; i++) if (TIERS[i].min > units) return TIERS[i]; return null; }
  function tierUnits() { return S.otherUnits + pageUnits(); }
  function basePrice(p, tier) { return tier && tier.prices ? num(tier.prices[REC[p.g]]) : 0; }
  function unitPrice(p, size, zip, tier) {
    return basePrice(p, tier) + (p.surch[size] || 0) + (zip && ZIP_G[p.g] ? ZIP : 0);
  }
  function productMoney(p, tier) {
    var t = 0, a = S.q[p.id];
    if (!a) return 0;
    Object.keys(a).forEach(function (d) {
      Object.keys(a[d]).forEach(function (rk) {
        var row = rowFor(p, rk); var zip = row ? row.zip : /\|zip$/.test(rk);
        Object.keys(a[d][rk]).forEach(function (s) { t += int(a[d][rk][s]) * unitPrice(p, s, zip, tier); });
      });
    });
    return Math.round(t * 100) / 100;
  }
  function pageMoney(tier) { var t = 0; P.forEach(function (p) { t += productMoney(p, tier); }); return Math.round(t * 100) / 100; }

  /* ── Cart lines: build (same format as sections/dtf-order.liquid) ───── */
  function linesFor(p) {
    var out = [], a = S.q[p.id];
    if (!a) return out;
    p.designs.concat(Object.keys(a).filter(function (d) { return p.designs.indexOf(d) < 0; })).forEach(function (d) {
      if (!a[d]) return;
      p.rows.forEach(function (row) {
        var c = a[d][row.key]; if (!c || !sumObj(c)) return;
        var sizes = {}; sizes[p.g] = {};
        p.sizes.concat(Object.keys(c).filter(function (s) { return p.sizes.indexOf(s) < 0; })).forEach(function (s) {
          var v = int(c[s]); if (v) sizes[p.g][sizeKey(s)] = v;
        });
        var style = '';
        if (p.styles.length) style = row.zip ? (p.zipStyle || '') : (p.plainStyle || '');
        out.push({ design: d, colour: row.colour, zip: row.zip ? 'yes' : 'no', style: style, notes: '', sizes: sizes });
      });
    });
    return out;
  }
  function propsFor(p, tier) {
    var lines = linesFor(p);
    var props = { 'Print method': 'DTF' };
    var first = lines[0];
    var prev = first ? ((p.img[first.design + '~' + first.colour] || p.designImg[first.design] || {}).url || p.imgs[0]) : p.imgs[0];
    if (prev) props['_preview_image'] = String(prev).indexOf('//') === 0 ? 'https:' + prev : prev;
    var total = 0, grand = 0;
    lines.forEach(function (line, i) {
      var head = 'Line ' + (i + 1);
      var bits = [];
      if (line.design) bits.push(line.design);
      if (line.colour) bits.push(line.colour);
      if (line.style) bits.push(line.style);
      else if (line.zip === 'yes') bits.push('Full Zip');
      if (bits.length) head += ' - ' + bits.join(' - ');
      var parts = [];
      p.sizes.forEach(function (s) { var v = int(line.sizes[p.g][sizeKey(s)]); if (v) parts.push(s + ' x' + v); });
      Object.keys(line.sizes[p.g]).forEach(function (k) { var s = sizeLabelFromKey(k); if (p.sizes.indexOf(s) < 0) parts.push(s + ' x' + line.sizes[p.g][k]); });
      props[head] = p.label + ': ' + parts.join(' ');
      Object.keys(line.sizes[p.g]).forEach(function (k) {
        var v = int(line.sizes[p.g][k]);
        total += v;
        grand += v * unitPrice(p, sizeLabelFromKey(k), line.zip === 'yes', tier);
      });
    });
    props['_tier_table'] = JSON.stringify(TIERS.map(function (t) { var pr = {}; pr[p.label] = money(basePrice(p, t)); return { min: t.min, p: pr }; }));
    props['Tier'] = tier ? (tier.min + '+ units | ' + p.label + ' ' + money(basePrice(p, tier))) : 'Below minimum';
    props['Total units'] = total;
    props['Order total'] = money(grand);
    props['Grand total'] = money(grand);
    var payload = JSON.stringify({ v: 1, lines: lines });
    if (payload.length > 30000) { delete props['_preview_image']; delete props['_tier_table']; }
    if (payload.length <= 45000) props['_dtf_payload'] = payload;
    return { props: props, units: total, grand: grand };
  }

  /* ── Cart lines: read back ─────────────────────────────────────────────── */
  function matchName(list, name) {
    var n = lc(name);
    for (var i = 0; i < list.length; i++) if (lc(list[i]) === n) return list[i];
    return null;
  }
  function linesFromProps(props) {
    if (props['_dtf_payload']) {
      var pl = json(props['_dtf_payload'], null);
      if (pl && Array.isArray(pl.lines)) return pl.lines;
    }
    var out = [];
    Object.keys(props).forEach(function (k) {
      var m = k.match(/^Line \d+\s*-\s*(.+)$/i);
      if (!m) return;
      var bits = m[1].split(' - ');
      var v = String(props[k] || '');
      var cut = v.search(/\r?\nNotes:/); if (cut >= 0) v = v.slice(0, cut);
      var zip = /full zip/i.test(m[1]);
      var line = { design: bits[0] || '', colour: bits[1] || '', zip: zip ? 'yes' : 'no', style: bits.slice(2).join(' - '), sizes: {} };
      v.split('|').forEach(function (grp) {
        var ci = grp.indexOf(':'); if (ci < 0) return;
        var gl = lc(grp.slice(0, ci));
        var code = null; Object.keys(LABEL).forEach(function (g) { if (lc(LABEL[g]) === gl) code = g; });
        if (!code) return;
        line.sizes[code] = line.sizes[code] || {};
        var toks = grp.slice(ci + 1).trim().split(/\s+/);
        for (var i = 0; i < toks.length - 1; i += 2) {
          if (/^x\d+$/i.test(toks[i + 1])) line.sizes[code][sizeKey(toks[i])] = int(toks[i + 1]);
        }
      });
      if (Object.keys(line.sizes).length) out.push(line);
    });
    return out;
  }
  function loadLines(p, lines, add) {
    lines.forEach(function (line) {
      var d = matchName(p.designs, line.design);
      if (d === null) { d = line.design || (p.designs.length === 1 ? p.designs[0] : ''); ensureDesign(p, d); }
      var c = matchName(p.colours, line.colour);
      if (c === null) {
        if (!line.colour && p.colours.length === 1) c = p.colours[0];
        else c = line.colour || '';
      }
      var zip = line.zip === 'yes' || /zip/i.test(line.style || '');
      if (zip && !ZIP_G[p.g]) zip = false;
      var rk = ensureRow(p, c, zip);
      Object.keys(line.sizes || {}).forEach(function (g) {
        Object.keys(line.sizes[g] || {}).forEach(function (k) {
          var s = normSize(sizeLabelFromKey(k), p.kids);
          var v = int(line.sizes[g][k]);
          if (!v) return;
          setQ(p.id, d, rk, s, (add ? getQ(p.id, d, rk, s) : 0) + v);
        });
      });
    });
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(readCart);
  }
  function syncFromCart(cart, keepQ) {
    var other = 0, keys = {}, fresh = {};
    var saved = S.q;
    S.q = fresh;
    (cart.items || []).forEach(function (it) {
      var pr = it.properties || {};
      var pm = pr['Print method'] || '';
      if (pm !== 'DTF' && pm !== 'Digital') return;
      var p = byId[it.product_id];
      if (!p) { other += int(pr['Total units']) || int(it.quantity); return; }
      (keys[p.id] = keys[p.id] || []).push(it.key);
      loadLines(p, linesFromProps(pr), true);
    });
    S.otherUnits = other;
    S.cartKeys = keys;
    S.baseline = qSig();
    if (keepQ) S.q = saved;
  }

  /* ── Draft (saved as you go) ───────────────────────────────────────────── */
  var saveTimer = null;
  function saveDraft() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        if (qSig() === S.baseline) localStorage.removeItem(DRAFT_KEY);
        else localStorage.setItem(DRAFT_KEY, JSON.stringify({ at: Date.now(), base: S.baseline, q: S.q, designs: S.design, cur: S.cur }));
      } catch (e) {}
    }, 250);
  }
  function loadDraft() {
    var d = null;
    try { d = json(localStorage.getItem(DRAFT_KEY), null); } catch (e) {}
    if (!d || d.base !== S.baseline || Date.now() - (d.at || 0) > 30 * 86400000) return false;
    S.q = d.q || {};
    P.forEach(function (p) {
      var a = S.q[p.id]; if (!a) return;
      Object.keys(a).forEach(function (dn) {
        ensureDesign(p, dn);
        Object.keys(a[dn]).forEach(function (rk) { var z = /\|zip$/.test(rk); ensureRow(p, rk.replace(/\|zip$/, ''), z); });
      });
    });
    // The garment and design come from the link the client clicked, not the draft
    if (d.designs && !/[?&]design=/.test(window.location.search)) Object.keys(d.designs).forEach(function (k) { if (byId[k] && k != S.cur) S.design[k] = d.designs[k]; });
    return true;
  }
  function clearDraft() { try { localStorage.removeItem(DRAFT_KEY); } catch (e) {} }

  /* ── Render: top half ──────────────────────────────────────────────────── */
  function curP() { return byId[S.cur]; }
  function curD() {
    var p = curP();
    if (S.design[p.id] != null) return S.design[p.id];
    var hit = null; p.designs.forEach(function (d) { if (hit === null && designUnits(p.id, d)) hit = d; });
    return hit !== null ? hit : p.designs[0];
  }
  function showDesigns(p) { return p.designs.length > 1 || (p.designs[0] && !/your artwork/i.test(p.designs[0])); }
  function selectedRow() {
    var p = curP(), d = curD();
    var rows = visRows(p);
    var k = S.open[p.id + '~' + d];
    for (var i = 0; i < rows.length; i++) if (rows[i].key === k) return rows[i];
    var best = null;
    rows.forEach(function (r) { if (!best && rowUnits(p.id, d, r.key)) best = r; });
    return best || rows[0];
  }
  function mainImage() {
    var p = curP(), d = curD(), row = selectedRow();
    if (S.main) return S.main;
    var a = row ? p.img[d + '~' + row.colour] : null;
    if (a) return a.url;
    if (p.designImg[d]) return p.designImg[d].url;
    return p.imgs[0] || '';
  }
  /* Thumbnails for one design: its colour photos, plus product photos that
     don't belong to any other design (front/back views, mockups). */
  function photoKey(u) { return String(u || '').split('?')[0]; }
  function designThumbs(p, d) {
    var mine = [], others = {};
    Object.keys(p.img).forEach(function (k) {
      var des = k.slice(0, k.indexOf('~')), u = p.img[k].url;
      if (des === d) mine.push(u); else others[photoKey(u)] = 1;
    });
    if (p.designImg[d]) mine.unshift(p.designImg[d].url);
    if (p.designs.length < 2) others = {};
    var mineKeys = {}; mine.forEach(function (u) { mineKeys[photoKey(u)] = 1; });
    var extra = p.imgs.filter(function (u) { var k = photoKey(u); return !others[k] && !mineKeys[k]; });
    var seen = {}, out = [];
    mine.concat(extra).forEach(function (u) { var k = photoKey(u); if (u && !seen[k]) { seen[k] = 1; out.push(u); } });
    return out.slice(0, 8);
  }
  function renderGallery() {
    var el = $('lid-gallery'); if (!el) return;
    var p = curP(), d = curD(), main = mainImage();
    var thumbs = designThumbs(p, d);
    var row = selectedRow();
    var cap = [d && showDesigns(p) ? d : '', row && row.colour ? row.colour : '', p.short].filter(Boolean).join(' · ');
    el.innerHTML =
      '<div class="lid-preview-box">' +
        (main ? '<img src="' + esc(main) + '" alt="' + esc(cap) + '" class="lid-main-img">' : '<div class="lid-noimg">' + esc(p.short) + '</div>') +
        '<span class="lid-cap">' + esc(cap) + '</span>' +
      '</div>' +
      (thumbs.length > 1 ? '<div class="lid-thumbs" role="list">' + thumbs.map(function (u) {
        return '<button type="button" role="listitem" class="lid-thumb' + (photoKey(u) === photoKey(main) ? ' is-active' : '') + '" data-act="thumb" data-src="' + esc(u) + '" aria-label="Show photo"><img src="' + esc(u) + '" alt="" loading="lazy"></button>';
      }).join('') + '</div>' : '');
  }
  function renderLadder() {
    var el = $('lid-ladder'); if (!el) return;
    var p = curP(), units = tierUnits(), now = tierAt(units);
    if (!TIERS.length) { el.textContent = ''; return; }
    el.innerHTML = TIERS.map(function (t) {
      var on = now && t.min === now.min && units >= TIERS[0].min;
      return '<span class="lid-step' + (on ? ' is-on' : '') + '"><b>' + t.min + '+</b> ' + money(basePrice(p, t)) + '</span>';
    }).join('') + '<span class="lid-ladder-note">each, inc GST · ' + esc(p.short) + '</span>';
  }
  function lastOrderLines() {
    var lo = data.last; if (!lo || !lo.lines) return [];
    var out = [];
    lo.lines.filter(Boolean).forEach(function (l) {
      var p = byId[l.pid] || null;
      if (!p) P.forEach(function (x) { if (!p && lc(String(l.title || '').replace(/\s*\(.*\)\s*$/, '')) === lc(x.title)) p = x; });
      if (!p) return;
      var lines = linesFromProps(l.props || {});
      if (lines.length) out.push({ p: p, lines: lines });
    });
    return out;
  }
  function renderLast() {
    var el = $('lid-last'); if (!el) return;
    var lol = lastOrderLines();
    if (!lol.length) { el.innerHTML = ''; return; }
    var n = 0;
    lol.forEach(function (x) { x.lines.forEach(function (l) { Object.keys(l.sizes || {}).forEach(function (g) { n += sumObj(l.sizes[g]); }); }); });
    el.innerHTML = '<div class="lid-last"><div><strong>Your last order</strong><span>' + esc(data.last.date || '') + ' · ' + n + ' pieces</span></div>' +
      '<button type="button" class="lid-btn lid-btn--ghost" data-act="reorder">Fill same sizes</button></div>';
  }
  function renderDesigns() {
    var el = $('lid-designs'); if (!el) return;
    var p = curP();
    if (!showDesigns(p)) { el.innerHTML = ''; return; }
    var d = curD();
    var list = p.designs;
    el.innerHTML = '<p class="lid-label"><span class="lid-num">' + (P.length > 1 ? 2 : 1) + '</span>Design' +
      (p.designs.length > 1 ? '<span class="lid-label-hint">Do one design at a time. They all go in the same order.</span>' : '') + '</p><div class="lid-designs">' + list.map(function (name) {
      var im = (p.designImg[name] || {}).url || '';
      var u = designUnits(p.id, name);
      return '<button type="button" class="lid-design' + (name === d ? ' is-on' : '') + '" data-act="design" data-name="' + esc(name) + '" aria-pressed="' + (name === d) + '">' +
        '<span class="lid-design-img">' + (p.isNew && p.isNew[name] ? '<span class="lid-new">New</span>' : '') + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '<span class="lid-design-txt">' + esc(name) + '</span>') + '</span>' +
        '<span class="lid-design-name"><span>' + esc(name || 'Design') + '</span>' + (u ? '<em data-units-design="' + esc(name) + '">' + u + '</em>' : '<em data-units-design="' + esc(name) + '" hidden></em>') + '</span>' +
      '</button>';
    }).join('') + '</div>';
    var on = el.querySelector('.lid-design.is-on');
    if (on && on.scrollIntoView && !S.desktop) { var row = on.parentNode; row.scrollLeft = Math.max(0, on.offsetLeft - 16); }
  }
  function renderGarments() {
    var el = $('lid-garments'); if (!el) return;
    if (P.length < 2) { el.innerHTML = ''; return; }
    var counts = {}; P.forEach(function (p) { counts[p.g] = (counts[p.g] || 0) + 1; });
    el.innerHTML = '<p class="lid-label"><span class="lid-num">1</span>Garment</p><div class="lid-pills" role="tablist">' + P.map(function (p) {
      var u = productUnits(p.id);
      var name = counts[p.g] > 1 ? p.title : p.short;
      return '<button type="button" role="tab" class="lid-pill' + (p.id === S.cur ? ' is-on' : '') + '" data-act="garment" data-id="' + p.id + '" aria-selected="' + (p.id === S.cur) + '">' +
        esc(name) + '<em data-units-product="' + p.id + '"' + (u ? '' : ' hidden') + '>' + u + '</em></button>';
    }).join('') + '</div>';
  }

  /* ── Render: the size board ────────────────────────────────────────────── */
  function rowThumb(p, d, row) {
    var a = p.img[d + '~' + row.colour];
    if (a) return '<span class="lid-rthumb"><img src="' + esc(a.url) + '" alt="" loading="lazy"></span>';
    return '<span class="lid-rthumb lid-rthumb--dot" style="--dot:' + swatch(row.colour) + '"></span>';
  }
  function rowSummary(p, d, row) {
    var bits = [];
    p.sizes.forEach(function (s) { var v = getQ(p.id, d, row.key, s); if (v) bits.push(s + ' ' + v); });
    return bits.join(' · ');
  }
  function sizeHead(p, s) {
    var sc = p.surch[s];
    return '<span class="lid-sh">' + esc(s) + (sc ? '<small>+' + money(sc) + '</small>' : '') + '</span>';
  }
  function boardHead(p, d) {
    var step = 1 + (P.length > 1 ? 1 : 0) + (showDesigns(p) ? 1 : 0);
    var title = [showDesigns(p) ? d : '', p.short].filter(Boolean).join(' · ');
    var sw = '';
    if (hasZip(p)) {
      var z = !!S.zipMode[p.id], nP = zipUnits(p, d, false), nZ = zipUnits(p, d, true);
      sw = '<div class="lid-style" role="group" aria-label="Style">' +
        '<button type="button" class="lid-style-btn' + (z ? '' : ' is-on') + '" data-act="zipmode" data-zip="0" aria-pressed="' + !z + '">' + (p.g === 'ahood' ? 'Pullover' : 'Crew neck') + (nP ? '<em>' + nP + '</em>' : '') + '</button>' +
        '<button type="button" class="lid-style-btn' + (z ? ' is-on' : '') + '" data-act="zipmode" data-zip="1" aria-pressed="' + z + '">Full zip <small>+' + money(ZIP) + '</small>' + (nZ ? '<em>' + nZ + '</em>' : '') + '</button>' +
        '</div>' + (z ? '<p class="lid-style-note">Full zip comes in black only.</p>' : '');
    }
    return '<div class="lid-board-head"><div class="lid-board-id"><h2 class="lid-board-title"><span class="lid-num">' + step + '</span>Sizes <span class="lid-board-sub">' + esc(title) + '</span></h2>' + sw + '</div><div class="lid-tools">' +
      (p.rec && p.rec.chart && p.rec.chart.rows && p.rec.chart.rows.length ? '<button type="button" class="lid-btn lid-btn--ghost" data-act="guide">Size guide</button>' : '') +
      '<button type="button" class="lid-btn lid-btn--ghost" data-act="split">Split for me</button>' +
      '<button type="button" class="lid-btn lid-btn--ghost" data-act="paste">Paste sizes</button>' +
      '</div></div>';
  }
  function renderBoard() {
    var el = $('lid-board'); if (!el) return;
    var p = curP(), d = curD();
    var html = boardHead(p, d);
    if (S.desktop) {
      html += '<div class="lid-matrix-wrap"><table class="lid-matrix"><thead><tr><th scope="col" class="lid-col-colour">Colour</th>' +
        p.sizes.map(function (s) { return '<th scope="col">' + sizeHead(p, s) + '</th>'; }).join('') +
        '<th scope="col" class="lid-col-units">Units</th><th scope="col"><span class="visually-hidden">Clear</span></th></tr></thead><tbody>' +
        visRows(p).map(function (row) {
          var u = rowUnits(p.id, d, row.key);
          return '<tr class="' + (u ? 'has-units' : '') + '"><th scope="row" class="lid-col-colour">' + rowThumb(p, d, row) + '<span>' + esc(row.label) + '</span></th>' +
            p.sizes.map(function (s) {
              if (!sizeOk(p, row, s)) return '<td class="is-na"><span aria-hidden="true">n/a</span></td>';
              var v = getQ(p.id, d, row.key, s);
              return '<td><input class="lid-stepper-input' + (v ? ' has-v' : '') + '" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" value="' + (v || '') + '" placeholder="0" data-row="' + esc(row.key) + '" data-size="' + esc(s) + '" aria-label="' + esc(row.label + ' ' + s) + '"></td>';
            }).join('') +
            '<td class="lid-col-units" data-units-row="' + esc(row.key) + '">' + (u || '') + '</td>' +
            '<td>' + (u ? '<button type="button" class="lid-x" data-act="clearrow" data-row="' + esc(row.key) + '" aria-label="Clear ' + esc(row.label) + '">&times;</button>' : '') + '</td></tr>';
        }).join('') + '</tbody></table></div>';
    } else {
      var openKey = (selectedRow() || {}).key;
      var explicit = S.open[p.id + '~' + d];
      var vr = visRows(p);
      html += '<div class="lid-cards">' + vr.map(function (row, idx) {
        var u = rowUnits(p.id, d, row.key);
        var isOpen = explicit === row.key || (!explicit && row.key === openKey && (u || idx === 0));
        if (explicit === '__none') isOpen = false;
        var sum = rowSummary(p, d, row);
        var next = vr[idx + 1];
        return '<div class="lid-card' + (isOpen ? ' is-open' : '') + '">' +
          '<button type="button" class="lid-card-head" data-act="openrow" data-row="' + esc(row.key) + '" aria-expanded="' + isOpen + '">' +
            rowThumb(p, d, row) +
            '<span class="lid-card-txt"><strong>' + esc(row.label) + '</strong><span data-sum-row="' + esc(row.key) + '">' + esc(sum || 'Tap to add sizes') + '</span></span>' +
            '<em class="lid-card-units" data-units-row="' + esc(row.key) + '"' + (u ? '' : ' hidden') + '>' + u + '</em>' +
            '<span class="lid-chev" aria-hidden="true"></span>' +
          '</button>' +
          (isOpen ? '<div class="lid-card-body"><div class="lid-steps">' + p.sizes.map(function (s) {
            if (!sizeOk(p, row, s)) return '';
            var v = getQ(p.id, d, row.key, s);
            return '<div class="lid-stepper"><span class="lid-stepper-lbl">' + sizeHead(p, s) + '</span><div class="lid-stepper-ctl' + (v ? ' has-v' : '') + '">' +
              '<button type="button" class="lid-stepper-btn" data-act="dec" data-row="' + esc(row.key) + '" data-size="' + esc(s) + '" aria-label="One less ' + esc(row.label + ' ' + s) + '">&minus;</button>' +
              '<input class="lid-stepper-input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" value="' + (v || '') + '" placeholder="0" data-row="' + esc(row.key) + '" data-size="' + esc(s) + '" aria-label="' + esc(row.label + ' ' + s) + '">' +
              '<button type="button" class="lid-stepper-btn" data-act="inc" data-row="' + esc(row.key) + '" data-size="' + esc(s) + '" aria-label="One more ' + esc(row.label + ' ' + s) + '">+</button>' +
            '</div></div>';
          }).join('') + '</div><div class="lid-card-actions">' +
            '<button type="button" class="lid-btn lid-btn--ghost" data-act="clearrow" data-row="' + esc(row.key) + '">Clear</button>' +
            (next ? '<button type="button" class="lid-btn lid-btn--ghost lid-grow" data-act="openrow" data-row="' + esc(next.key) + '">Next: ' + esc(next.label) + '</button>' :
              '<button type="button" class="lid-btn lid-btn--ghost lid-grow" data-act="openrow" data-row="__none">Done</button>') +
          '</div></div>' : '') +
        '</div>';
      }).join('') + '</div>';
    }
    var capped = p.capIdx >= 0 && visRows(p).some(function (r) { return !isBlack(r.colour); });
    if (capped) html += '<p class="lid-board-note"><b>n/a</b> Colours other than black go up to ' + esc(p.sizes[p.capIdx]) + '. Bigger sizes come in black.</p>';
    el.innerHTML = html;
  }

  /* ── Render: the sticky price bar ──────────────────────────────────────── */
  function state() {
    var units = tierUnits(), tier = tierAt(units), nxt = nextTier(units);
    var mny = pageMoney(tier);
    var had = Object.keys(S.cartKeys).length > 0;
    var dirty = qSig() !== S.baseline;
    return { units: units, page: pageUnits(), tier: tier, next: nxt, money: mny, gst: Math.round(mny / 11 * 100) / 100, had: had, dirty: dirty };
  }
  function renderBar() {
    var el = $('lid-bar'); if (!el) return;
    var st = state();
    el.hidden = false;
    // Progress: one segment per price break, 0 to 25, 25 to 50, 50 to 100, 100 to 250
    var segs = TIERS.map(function (t, i) {
      var start = i ? TIERS[i - 1].min : 0, span = Math.max(1, t.min - start);
      var fill = Math.max(0, Math.min(100, Math.round((st.units - start) / span * 100)));
      var on = st.units >= t.min, cur = st.tier && st.tier.min === t.min && on;
      return '<span class="lid-seg' + (on ? ' is-on' : '') + (cur ? ' is-cur' : '') + '"><span class="lid-seg-bar"><i style="width:' + fill + '%"></i></span><b>' + t.min + '+</b></span>';
    }).join('');
    var nextTxt = '', noPrices = !TIERS.length;
    if (noPrices) nextTxt = 'Prices could not load. Refresh the page, or email info@luckyinger.com.au.';
    else if (st.units < MIN) nextTxt = (MIN - st.units) + ' more to reach the ' + MIN + ' piece minimum';
    else if (st.next) {
      var save = Math.round((pageMoney(st.tier) - pageMoney(st.next)) * 100) / 100;
      nextTxt = (st.next.min - st.units) + ' more for the ' + st.next.min + '+ price' + (save > 0 ? ', saves ' + moneyC(save) : '');
    } else nextTxt = 'Best price reached';
    var label, disabled = false;
    if (S.busy) { label = 'Saving...'; disabled = true; }
    else if (st.had) label = 'Update order';
    else label = 'Add to order';
    if ((!st.page && !st.had) || noPrices) disabled = true;
    var done = st.had && !st.dirty && !S.busy;
    el.innerHTML =
      '<div class="lid-dock">' +
        (S.msg ? '<p class="lid-bar-msg' + (S.msgKind ? ' is-' + S.msgKind : '') + '" role="' + (S.msgKind === 'error' ? 'alert' : 'status') + '">' + esc(S.msg) + '</p>' : '') +
        '<div class="lid-dock-in">' +
          '<div class="lid-dock-progress">' +
            '<p class="lid-dock-count"><strong>' + st.units + '</strong> piece' + (st.units === 1 ? '' : 's') +
              (S.otherUnits ? '<span class="lid-dim"> (' + S.otherUnits + ' already in cart)</span>' : '') +
              (st.dirty && st.page ? '<span class="lid-pending">Not in your order yet</span>' : (st.had ? '<span class="lid-inorder">In your order</span>' : '')) + '</p>' +
            (TIERS.length ? '<div class="lid-segs" aria-hidden="true">' + segs + '</div>' : '') +
            '<p class="lid-bar-next">' + esc(nextTxt) + '</p>' +
          '</div>' +
          '<div class="lid-dock-total">' +
            '<span class="lid-dock-label">Total inc GST</span>' +
            '<strong>' + moneyC(st.money) + '</strong>' +
            '<button type="button" class="lid-link" data-act="breakdown">Includes ' + moneyC(st.gst) + ' GST &middot; Breakdown</button>' +
          '</div>' +
          '<div class="lid-dock-actions">' +
            '<button type="button" class="lid-btn lid-btn--ghost lid-hide-sm" data-act="quote"' + (st.page && !noPrices ? '' : ' disabled') + '>Download quote</button>' +
            (done ? '<a class="lid-btn lid-btn--go is-done" href="/cart">In your order &middot; Review</a>' :
              '<button type="button" class="lid-btn lid-btn--go" data-act="submit"' + (disabled ? ' disabled' : '') + '>' + esc(label) + '</button>') +
          '</div>' +
        '</div>' +
      '</div>';
  }

  /* Light update while typing: keeps focus in the box being edited. */
  function refreshNumbers() {
    var p = curP(), d = curD();
    Array.prototype.forEach.call(document.querySelectorAll('[data-units-row]'), function (el) {
      var u = rowUnits(p.id, d, el.getAttribute('data-units-row'));
      el.textContent = u || '';
      if (el.tagName === 'EM') el.hidden = !u;
      var tr = el.closest('tr'); if (tr) tr.classList.toggle('has-units', !!u);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-sum-row]'), function (el) {
      var row = rowFor(p, el.getAttribute('data-sum-row'));
      if (row) el.textContent = rowSummary(p, d, row) || 'Tap to add sizes';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-units-design]'), function (el) {
      var u = designUnits(p.id, el.getAttribute('data-units-design'));
      el.textContent = u; el.hidden = !u;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-units-product]'), function (el) {
      var u = productUnits(el.getAttribute('data-units-product'));
      el.textContent = u; el.hidden = !u;
    });
    Array.prototype.forEach.call(document.querySelectorAll('.lid-style-btn'), function (b) {
      var n = zipUnits(p, d, b.getAttribute('data-zip') === '1'), em = b.querySelector('em');
      if (n && !em) { em = document.createElement('em'); b.appendChild(em); }
      if (em) { if (n) em.textContent = n; else em.remove(); }
    });
    renderLadder();
    renderBar();
  }
  function renderAll() {
    renderGallery(); renderLadder(); renderLast(); renderDesigns(); renderGarments(); renderBoard(); renderBar();
  }
  function changed(full) { saveDraft(); if (full) renderAll(); else refreshNumbers(); }

  /* ── Toast with undo ─────────────────────────────────────────────────── */
  var toastTimer = null;
  function toast(text, undoSnap) {
    var t = $('lid-toast');
    if (!t) { t = document.createElement('div'); t.id = 'lid-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    S.undo = undoSnap || null;
    t.innerHTML = '<span>' + esc(text) + '</span>' + (undoSnap ? '<button type="button" data-act="undo">Undo</button>' : '');
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; S.undo = null; }, 7000);
  }

  /* ── Modals ──────────────────────────────────────────────────────────────── */
  function modal(title, body, foot) {
    closeModal();
    var m = document.createElement('div');
    m.id = 'lid-modal'; m.className = 'lid-modal';
    m.innerHTML = '<div class="lid-modal-box" role="dialog" aria-modal="true" aria-label="' + esc(title) + '">' +
      '<div class="lid-modal-head"><h2>' + esc(title) + '</h2><button type="button" class="lid-x" data-act="close" aria-label="Close">&times;</button></div>' +
      '<div class="lid-modal-body">' + body + '</div>' + (foot ? '<div class="lid-modal-foot">' + foot + '</div>' : '') + '</div>';
    document.body.appendChild(m);
    document.documentElement.classList.add('lid-modal-open');
    var f = m.querySelector('textarea, input, button:not([data-act="close"])');
    setTimeout(function () { (f || m.querySelector('button')).focus(); }, 30);
    return m;
  }
  function closeModal() {
    var m = $('lid-modal'); if (m) m.remove();
    document.documentElement.classList.remove('lid-modal-open');
  }
  function openGuide() {
    var p = curP(), ch = p.rec && p.rec.chart;
    if (!ch || !ch.rows) return;
    var cols = ch.cols || ['Chest', 'Length'];
    modal('Size guide', '<p class="lid-dim">' + esc(ch.title || p.short) + ' · measured flat, cm</p>' +
      '<table class="lid-guide"><thead><tr><th>Size</th>' + cols.map(function (c) { return '<th>' + esc(c) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      ch.rows.map(function (r) { return '<tr><th>' + esc(r[0]) + '</th>' + r.slice(1).map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>'; }).join('') +
      '</tbody></table>' + (ch.note ? '<p class="lid-dim">' + esc(ch.note) + '</p>' : ''));
  }
  function openSplit() {
    var p = curP(), row = selectedRow();
    modal('Split for me', '<p>Enter how many you need and we\'ll spread them across the usual sizes. You can adjust after.</p>' +
      '<label class="lid-field"><span>Colour</span><select id="lid-split-row">' + visRows(p).map(function (r) {
        return '<option value="' + esc(r.key) + '"' + (row && r.key === row.key ? ' selected' : '') + '>' + esc(r.label) + '</option>';
      }).join('') + '</select></label>' +
      '<label class="lid-field"><span>How many</span><input id="lid-split-n" type="text" inputmode="numeric" pattern="[0-9]*" placeholder="e.g. 50"></label>',
      '<button type="button" class="lid-btn lid-btn--ghost" data-act="close">Cancel</button><button type="button" class="lid-btn lid-btn--go" data-act="dosplit">Fill sizes</button>');
  }
  function doSplit() {
    var p = curP(), d = curD();
    var rk = ($('lid-split-row') || {}).value, n = int(($('lid-split-n') || {}).value);
    var row = rowFor(p, rk);
    if (!row || !n) return;
    var plan = (p.kids ? KSPLIT : SPLIT).filter(function (x) { return sizeOk(p, row, x[0]); });
    if (!plan.length) plan = p.sizes.filter(function (s) { return sizeOk(p, row, s); }).map(function (s) { return [s, 1]; });
    var tot = plan.reduce(function (s, x) { return s + x[1]; }, 0) || 1;
    var parts = plan.map(function (x) { var e = n * x[1] / tot; return { s: x[0], n: Math.floor(e), r: e - Math.floor(e) }; });
    var left = n - parts.reduce(function (s, x) { return s + x.n; }, 0);
    parts.slice().sort(function (a, b) { return b.r - a.r; }).slice(0, left).forEach(function (x) { x.n++; });
    var snap = snapshot();
    p.sizes.forEach(function (s) { setQ(p.id, d, rk, s, 0); });
    parts.forEach(function (x) { setQ(p.id, d, rk, x.s, x.n); });
    S.open[p.id + '~' + d] = rk;
    closeModal(); changed(true);
    toast(n + ' spread across ' + row.label, snap);
  }

  /* Paste: lists ("M 12, L 20"), spreadsheet grids with a size header row, and
     heading lines that name a design, garment, colour or "zip" for the lines
     below. Shows what it found before filling. */
  function sizeTok(t, kids) {
    var s = String(t || '').toUpperCase().replace(/[.:]$/, '');
    if (!s) return null;
    var map = { SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL', SML: 'S', MED: 'M', LRG: 'L', XLG: 'XL' };
    if (map[s]) s = map[s];
    s = s.replace(/^(\d+)[-\/](\d+)XL$/, '$1/$2XL').replace(/^(\d)X$/, '$1XL');
    if (ADULT.indexOf(s) >= 0) return s;
    var k = s.match(/^K(\d{1,2})$/) || (kids ? s.match(/^(\d{1,2})$/) : null);
    if (k && KIDS.indexOf('K' + k[1]) >= 0) return 'K' + k[1];
    return null;
  }
  function numTok(t) { var m = String(t || '').match(/^x?(\d{1,5})x?$/i); return m ? int(m[1]) : null; }
  function findIn(low, names) {
    var hit = null;
    names.filter(Boolean).slice().sort(function (a, b) { return b.length - a.length; }).some(function (n) {
      var re = new RegExp('(^|[^a-z0-9])' + n.toLowerCase().replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&') + '([^a-z0-9]|$)');
      if (re.test(low)) { hit = n; return true; }
      return false;
    });
    return hit;
  }
  function garmentIn(low) {
    var g = null;
    if (/\bkids?\b|\byouth\b/.test(low)) {
      if (/hood|jumper/.test(low)) g = 'khood'; else if (/sweat|crew/.test(low)) g = 'ksweat'; else g = 'ktee';
    } else if (/\bhood(ie|ies|y|s)?\b|\bjumpers?\b/.test(low)) g = 'ahood';
    else if (/\bsweat(er|ers|s)?\b|\bcrew\b/.test(low)) g = 'asweat';
    else if (/\bsinglets?\b/.test(low)) g = 'asinglet';
    else if (/\btanks?\b/.test(low)) g = 'atank';
    else if (/\b(tees?|t-?shirts?|shirts?)\b/.test(low)) g = 'atee';
    return g;
  }
  function productForGarment(g) {
    var hit = null;
    if (curP().g === g) return curP();
    P.forEach(function (p) { if (!hit && p.g === g) hit = p; });
    return hit;
  }
  function parsePaste(text) {
    var found = [], skipped = [];
    var allDesigns = uniq([].concat.apply([], P.map(function (p) { return p.designs; })));
    var allColours = uniq([].concat.apply([], P.map(function (p) { return p.colours; })));
    var cur = { p: curP(), d: curD(), c: (selectedRow() || {}).colour || '', zip: false };
    // A design or colour carried over from another garment may be spelt a
    // little differently on this one ("OG TRUCK" vs "TRUCK").
    function fit(list, name, fallback) {
      var hit = matchName(list, name);
      if (hit !== null) return hit;
      var l = lc(name);
      list.some(function (x) { if (x && l && (l.indexOf(lc(x)) >= 0 || lc(x).indexOf(l) >= 0)) { hit = x; return true; } return false; });
      return hit !== null ? hit : fallback;
    }
    function add(p, d, c, zip, s, n) {
      if (!p || !n) return;
      d = fit(p.designs, d, S.design[p.id] != null ? S.design[p.id] : p.designs[0]);
      c = fit(p.colours, c, p.colours.length === 1 ? p.colours[0] : c);
      found.push({ p: p, d: d, c: c, zip: zip && !!ZIP_G[p.g], s: s, n: n });
    }
    function ctx(raw) {
      var low = ' ' + String(raw || '').toLowerCase() + ' ', o = {};
      var d = findIn(low, allDesigns); if (d) { o.d = d; low = low.replace(d.toLowerCase(), ' '); }
      var c = findIn(low, allColours); if (c) { o.c = c; low = low.replace(c.toLowerCase(), ' '); }
      var g = garmentIn(low); if (g) { o.g = g; low = low.replace(/\b(kids?|youth|hood(ie|ies|y|s)?|jumpers?|sweat(er|ers|s)?|crew|singlets?|tanks?|tees?|t-?shirts?|shirts?)\b/g, ' '); }
      if (/\b(full\s*)?zip(ped|s)?\b/.test(low)) { o.zip = true; low = low.replace(/\b(full\s*)?zip(ped|s)?\b/g, ' '); }
      o.rest = low;
      return o;
    }
    var lines = String(text || '').split(/\r?\n/).filter(function (l) { return l.trim(); });
    if (!lines.length) return { found: found, skipped: skipped };
    var cells = function (l) { return l.split(/\t|,|;|\|/).map(function (x) { return x.trim(); }); };
    var head = cells(lines[0]);
    var kidsHead = head.map(function (h) { return sizeTok(h, true); }).filter(Boolean).length > head.map(function (h) { return sizeTok(h, false); }).filter(Boolean).length;
    var hs = head.map(function (h) { return sizeTok(h, kidsHead); });
    if (hs.filter(Boolean).length >= 2) {
      lines.slice(1).forEach(function (l) {
        var cs = cells(l), any = false;
        var c = ctx(hs[0] ? '' : cs[0]);
        var p = c.g ? productForGarment(c.g) : (kidsHead ? productForGarment(cur.p.kids ? cur.p.g : 'ktee') : (cur.p.kids ? productForGarment('atee') : cur.p));
        var d = c.d || cur.d, col = c.c || cur.c;
        hs.forEach(function (s, i) { var n = s ? numTok(cs[i]) : null; if (s && n) { add(p || cur.p, d, col, c.zip, s, n); any = true; } });
        if (!any && (c.d || c.c || c.g)) { if (c.d) cur.d = c.d; if (c.c) cur.c = c.c; if (c.g && productForGarment(c.g)) cur.p = productForGarment(c.g); return; }
        if (!any) skipped.push(l.trim());
      });
      return { found: found, skipped: skipped };
    }
    lines.forEach(function (l) {
      var c = ctx(l);
      var p = c.g ? productForGarment(c.g) : cur.p;
      var kids = p ? p.kids : false;
      var toks = c.rest.replace(/([a-z])(x\d)/gi, '$1 $2').split(/[\s,;:=|()]+|-(?!\d)/).filter(Boolean);
      // Pairs read left to right: "M 12 L 20" (size first) or "12 M, 20 L"
      // (number first, when the line starts with a number that isn't a size).
      // Kids sizes are bare numbers, so "4 5, 6 10" is K4 x5, K6 x10.
      var hits = [], i = 0;
      var numFirst = toks.length > 1 && numTok(toks[0]) !== null && !sizeTok(toks[0], kids) && !!sizeTok(toks[1], kids);
      while (i < toks.length) {
        var s = null, n = null;
        if (numFirst) {
          if (numTok(toks[i]) !== null && i + 1 < toks.length && sizeTok(toks[i + 1], kids)) { n = numTok(toks[i]); s = sizeTok(toks[i + 1], kids); i += 2; }
          else i++;
        } else {
          s = sizeTok(toks[i], kids);
          if (s && i + 1 < toks.length && numTok(toks[i + 1]) !== null) { n = numTok(toks[i + 1]); i += 2; }
          else { if (s) n = 1; i++; }
        }
        if (s && n) hits.push([s, n]);
      }
      if (!hits.length) {
        if (c.d || c.c || c.g || c.zip) {
          if (c.d) cur.d = c.d; if (c.c) cur.c = c.c; if (c.g && p) cur.p = p; cur.zip = !!c.zip;
        } else skipped.push(l.trim());
        return;
      }
      var d = c.d || cur.d, col = c.c || cur.c, zip = c.zip || (!c.c && cur.zip);
      hits.forEach(function (h) { add(p || cur.p, d, col, zip, h[0], h[1]); });
    });
    return { found: found, skipped: skipped };
  }
  function openPaste() {
    modal('Paste sizes', '<p>Paste a list or a spreadsheet. A line can name the design, colour, garment and "zip". A line with just a name sets it for the lines below.</p>' +
      '<textarea id="lid-paste-txt" rows="7" placeholder="Black&#10;S 10, M 20, L 25, XL 15&#10;Hoodie full zip&#10;M 6, L 8"></textarea>' +
      '<div id="lid-paste-out" class="lid-paste-out"></div>',
      '<button type="button" class="lid-btn lid-btn--ghost" data-act="close">Cancel</button><button type="button" class="lid-btn lid-btn--go" data-act="dopaste" disabled>Fill</button>');
  }
  var pasteResult = null;
  function previewPaste() {
    var t = $('lid-paste-txt'), out = $('lid-paste-out'), go = document.querySelector('[data-act="dopaste"]');
    if (!t || !out) return;
    pasteResult = parsePaste(t.value);
    var groups = {};
    pasteResult.found.forEach(function (f) {
      var k = f.p.id + '|' + f.d + '|' + f.c + '|' + f.zip;
      var g = groups[k] || (groups[k] = { label: [f.p.short, f.d, f.c, f.zip ? 'full zip' : ''].filter(Boolean).join(' · '), sizes: {}, n: 0 });
      g.sizes[f.s] = (g.sizes[f.s] || 0) + f.n; g.n += f.n;
    });
    var keys = Object.keys(groups);
    out.innerHTML = keys.length ? '<p class="lid-label">Found</p><ul>' + keys.map(function (k) {
      var g = groups[k];
      return '<li><strong>' + esc(g.label) + '</strong> ' + Object.keys(g.sizes).map(function (s) { return esc(s) + ' ' + g.sizes[s]; }).join(' · ') + ' <em>' + g.n + '</em></li>';
    }).join('') + '</ul>' + (pasteResult.skipped.length ? '<p class="lid-dim">Skipped: ' + esc(pasteResult.skipped.slice(0, 3).join(' / ')) + '</p>' : '')
      : (t.value.trim() ? '<p class="lid-dim">No sizes found yet.</p>' : '');
    if (go) go.disabled = !keys.length;
  }
  function doPaste() {
    if (!pasteResult || !pasteResult.found.length) return;
    var snap = snapshot(), n = 0;
    var target = {};
    pasteResult.found.forEach(function (f) {
      ensureDesign(f.p, f.d);
      var c = matchName(f.p.colours, f.c); if (c === null) c = f.c || f.p.colours[0];
      var rk = ensureRow(f.p, c, f.zip);
      var key = f.p.id + '\u0001' + f.d + '\u0001' + rk + '\u0001' + f.s;
      target[key] = (target[key] || 0) + f.n;
      n += f.n;
    });
    Object.keys(target).forEach(function (k) {
      var a = k.split('\u0001');
      setQ(a[0], a[1], a[2], a[3], target[k]);
    });
    var f0 = pasteResult.found[0];
    S.cur = f0.p.id; S.design[f0.p.id] = f0.d; S.zipMode[f0.p.id] = !!f0.zip;
    closeModal(); changed(true);
    toast(n + ' pieces filled from your list', snap);
  }
  function reorder() {
    var lol = lastOrderLines(); if (!lol.length) return;
    var snap = snapshot();
    // Same sizes as last time: those garments start fresh, then fill (undo brings back what was there)
    lol.forEach(function (x) { S.q[x.p.id] = {}; });
    lol.forEach(function (x) { loadLines(x.p, x.lines, true); });
    S.cur = lol[0].p.id;
    changed(true);
    toast('Filled the sizes from your last order', snap);
  }

  /* Breakdown and printable quote */
  function breakdownRows(tier) {
    var rows = [];
    P.forEach(function (p) {
      linesFor(p).forEach(function (line) {
        var units = 0, mny = 0, sizes = [];
        p.sizes.concat(Object.keys(line.sizes[p.g]).map(sizeLabelFromKey).filter(function (s) { return p.sizes.indexOf(s) < 0; })).forEach(function (s) {
          var v = int(line.sizes[p.g][sizeKey(s)]); if (!v) return;
          units += v; mny += v * unitPrice(p, s, line.zip === 'yes', tier); sizes.push(s + ' ' + v);
        });
        rows.push({ p: p, line: line, units: units, money: Math.round(mny * 100) / 100, sizes: sizes });
      });
    });
    return rows;
  }
  function openBreakdown() {
    var st = state(), rows = breakdownRows(st.tier);
    modal('Price breakdown', rows.length ? '<table class="lid-bd"><tbody>' + rows.map(function (r) {
      return '<tr><td><strong>' + esc([r.p.short, showDesigns(r.p) ? r.line.design : '', r.line.colour, r.line.zip === 'yes' ? 'full zip' : ''].filter(Boolean).join(' · ')) + '</strong><span>' + esc(r.sizes.join(' · ')) + '</span></td><td>' + r.units + '</td><td>' + moneyC(r.money) + '</td></tr>';
    }).join('') + '</tbody><tfoot><tr><td>' + (st.tier ? st.tier.min + '+ price' + (S.otherUnits ? ', counting ' + S.otherUnits + ' already in your cart' : '') : '') + '</td><td>' + st.page + '</td><td>' + moneyC(st.money) + '</td></tr></tfoot></table>' +
      '<p class="lid-dim">Includes ' + moneyC(st.gst) + ' GST. Freight billed at cost after completion. ' + esc(data.turn || '') + '</p>' : '<p>Nothing entered yet.</p>',
      '<button type="button" class="lid-btn lid-btn--ghost" data-act="close">Close</button>' + (rows.length ? '<button type="button" class="lid-btn lid-btn--go" data-act="quote">Download quote</button>' : ''));
  }
  function printQuote() {
    var st = state(), rows = breakdownRows(st.tier);
    if (!rows.length) return;
    var old = $('lid-print'); if (old) old.remove();
    var el = document.createElement('div');
    el.id = 'lid-print';
    var today = new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
    el.innerHTML = '<div class="lid-q"><div class="lid-q-head"><div><h1>Quote</h1><p>' + esc(data.shop || 'Lucky Inger Design') + '<br>info@luckyinger.com.au</p></div><div><p><strong>' + esc(document.querySelector('.lid-title') ? document.querySelector('.lid-title').textContent : '') + '</strong><br>' + esc(today) + '</p></div></div>' +
      '<table><thead><tr><th>Item</th><th>Sizes</th><th>Qty</th><th>Amount</th></tr></thead><tbody>' + rows.map(function (r) {
        return '<tr><td>' + esc([r.p.title, r.line.design, r.line.colour, r.line.zip === 'yes' ? 'Full zip' : ''].filter(Boolean).join(' · ')) + '</td><td>' + esc(r.sizes.join(', ')) + '</td><td>' + r.units + '</td><td>' + moneyC(r.money) + '</td></tr>';
      }).join('') + '</tbody><tfoot><tr><td colspan="2">Total inc GST' + (st.tier ? ' (' + st.tier.min + '+ price)' : '') + '</td><td>' + st.page + '</td><td>' + moneyC(st.money) + '</td></tr>' +
      '<tr><td colspan="2">Includes GST</td><td></td><td>' + moneyC(st.gst) + '</td></tr></tfoot></table>' +
      '<p>Prices include GST. Freight billed at cost after completion. ' + esc(data.turn || '') + '. Prices are per the quantity break shown; all printed garments in one order count toward the break. Valid for 30 days.</p></div>';
    document.body.appendChild(el);
    document.documentElement.classList.add('lid-printing');
    var done = function () { document.documentElement.classList.remove('lid-printing'); el.remove(); window.removeEventListener('afterprint', done); };
    window.addEventListener('afterprint', done);
    setTimeout(function () { window.print(); }, 50);
  }

  /* ── Submit ──────────────────────────────────────────────────────────────── */
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(readCart);
  }
  function submit() {
    if (S.busy) return;
    var st = state();
    if (!st.page && !st.had) return;
    S.busy = true; S.msg = ''; renderBar();
    var tier = st.tier, chain = Promise.resolve(), adds = [];
    P.forEach(function (p) {
      var keys = (S.cartKeys[p.id] || []).slice();
      var built = productUnits(p.id) ? propsFor(p, tier) : null;
      if (built && built.units > 0) {
        if (keys.length) {
          var k0 = keys.shift();
          chain = chain.then(function () { return post('/cart/change.js', { id: k0, quantity: built.units, properties: built.props }); });
        } else {
          adds.push({ id: p.variantId, quantity: built.units, properties: built.props });
        }
      }
      keys.forEach(function (k) { chain = chain.then(function () { return post('/cart/change.js', { id: k, quantity: 0 }); }); });
    });
    chain.then(function () { return adds.length ? post('/cart/add.js', { items: adds }) : null; })
      .then(fetchCart)
      .then(function (cart) {
        syncFromCart(cart, false);
        clearDraft();
        S.busy = false;
        S.msg = st.had ? 'Order updated.' : 'Added to your order.';
        S.msgKind = 'ok';
        renderAll();
        if (window.LIOrder && window.LIOrder.updateBadge) window.LIOrder.updateBadge();
        if (window.LIShowCartPopup) {
          var cp = curP(), pic = (cp.designImg[curD()] || {}).url || cp.imgs[0] || '';
          window.LIShowCartPopup({ label: st.had ? 'Order updated' : 'Added to your order', title: ((document.querySelector('.lid-title') || {}).textContent || cp.title) + ' \u00b7 Digital print', sub: st.page + ' pieces on this page \u00b7 ' + moneyC(st.money) + ' inc GST', imgSrc: pic ? (pic.indexOf('//') === 0 ? 'https:' + pic : pic) : '', stayLabel: 'Keep ordering' });
          S.msg = ''; renderBar();
        }
        setTimeout(function () { if (S.msgKind === 'ok') { S.msg = ''; renderBar(); } }, 4000);
      })
      .catch(function (err) {
        console.error('DTF order', err);
        S.busy = false;
        S.msg = 'Could not save to your order: ' + ((err && err.message) || 'cart error') + '. Please try again.';
        S.msgKind = 'error';
        fetchCart().then(function (cart) { syncFromCart(cart, true); renderBar(); }).catch(function () { renderBar(); });
      });
  }

  /* ── Events ──────────────────────────────────────────────────────────────── */
  function onClick(e) {
    var el = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!el) {
      if (e.target.id === 'lid-modal') closeModal();
      return;
    }
    if (!el.closest('#lid-root, #lid-bar, #lid-modal, #lid-toast')) return;
    var act = el.getAttribute('data-act'), p = curP(), d = curD();
    if (act === 'thumb') { S.main = el.getAttribute('data-src'); renderGallery(); }
    else if (act === 'design') { S.design[p.id] = el.getAttribute('data-name'); S.main = null; renderAll(); saveDraft(); }
    else if (act === 'garment') { var np = byId[Number(el.getAttribute('data-id'))]; if (np && S.design[np.id] == null) S.design[np.id] = fitName(np.designs, d, np.designs[0]); S.cur = np ? np.id : S.cur; S.main = null; renderAll(); saveDraft(); }
    else if (act === 'inc' || act === 'dec') {
      var rk = el.getAttribute('data-row'), s = el.getAttribute('data-size');
      var v = getQ(p.id, d, rk, s) + (act === 'inc' ? 1 : -1);
      setQ(p.id, d, rk, s, v);
      var inp = el.parentNode.querySelector('.lid-stepper-input');
      if (inp) { var nv = getQ(p.id, d, rk, s); inp.value = nv || ''; el.parentNode.classList.toggle('has-v', !!nv); }
      changed(false);
    }
    else if (act === 'openrow') {
      var k = el.getAttribute('data-row'), cur = S.open[p.id + '~' + d];
      S.open[p.id + '~' + d] = (cur === k && el.classList.contains('lid-card-head')) ? '__none' : k;
      S.main = null;
      renderBoard(); renderGallery();
      if (k !== '__none') { var c = document.querySelector('.lid-card.is-open'); if (c && el.classList.contains('lid-grow')) c.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    }
    else if (act === 'clearrow') {
      var rk2 = el.getAttribute('data-row'), snap = snapshot(), row = rowFor(p, rk2);
      p.sizes.forEach(function (s2) { setQ(p.id, d, rk2, s2, 0); });
      var a = S.q[p.id] && S.q[p.id][d]; if (a && a[rk2]) a[rk2] = {};
      changed(true);
      toast('Cleared ' + (row ? row.label : 'row'), snap);
    }
    else if (act === 'undo') { if (S.undo) { restore(S.undo); S.undo = null; var t = $('lid-toast'); if (t) t.hidden = true; changed(true); } }
    else if (act === 'zipmode') { S.zipMode[p.id] = el.getAttribute('data-zip') === '1'; S.main = null; renderBoard(); renderGallery(); }
    else if (act === 'reorder') reorder();
    else if (act === 'guide') openGuide();
    else if (act === 'split') openSplit();
    else if (act === 'dosplit') doSplit();
    else if (act === 'paste') openPaste();
    else if (act === 'dopaste') doPaste();
    else if (act === 'breakdown') openBreakdown();
    else if (act === 'quote') { closeModal(); printQuote(); }
    else if (act === 'close') closeModal();
    else if (act === 'submit') submit();
  }
  function onInput(e) {
    var t = e.target;
    if (t.id === 'lid-paste-txt') { previewPaste(); return; }
    if (!t.classList || !t.classList.contains('lid-stepper-input') || !t.closest('#lid-root')) return;
    var p = curP(), d = curD();
    var clean = String(t.value).replace(/[^0-9]/g, '').slice(0, 5);
    if (clean !== t.value) t.value = clean;
    setQ(p.id, d, t.getAttribute('data-row'), t.getAttribute('data-size'), clean);
    t.classList.toggle('has-v', !!int(clean));
    if (t.parentNode.classList.contains('lid-stepper-ctl')) t.parentNode.classList.toggle('has-v', !!int(clean));
    changed(false);
  }
  function onKey(e) {
    if (e.key === 'Escape' && $('lid-modal')) closeModal();
    if (e.key === 'Enter' && e.target.id === 'lid-split-n') { e.preventDefault(); doSplit(); }
    // Arrow keys move around the desktop grid like a spreadsheet
    var t = e.target;
    if (!S.desktop || !t.classList || !t.classList.contains('lid-stepper-input') || e.shiftKey) return;
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) < 0) return;
    if ((e.key === 'ArrowLeft' && t.selectionStart > 0) || (e.key === 'ArrowRight' && t.selectionEnd < t.value.length)) return;
    var td = t.closest('td'), tr = t.closest('tr'); if (!td || !tr) return;
    var col = Array.prototype.indexOf.call(tr.children, td);
    var target = null;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      var cells = Array.prototype.slice.call(tr.querySelectorAll('.lid-stepper-input'));
      target = cells[cells.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1)];
    } else {
      var r = e.key === 'ArrowDown' ? tr.nextElementSibling : tr.previousElementSibling;
      while (r && !target) { var c2 = r.children[col]; target = c2 ? c2.querySelector('.lid-stepper-input') : null; if (!target) r = e.key === 'ArrowDown' ? r.nextElementSibling : r.previousElementSibling; }
    }
    if (target) { e.preventDefault(); target.focus(); try { target.select(); } catch (x) {} }
  }

  /* "New" badge: a design first added in the last 45 days, and at least a week after the
     product's first designs (so a brand new client doesn't get NEW on everything).
     Dates come from the product's public JSON (/products/handle.json, variant created_at). */
  function loadNewDesigns() {
    P.forEach(function (p) {
      if (!p.url || !window.fetch) return;
      fetch(String(p.url).split('?')[0] + '.json', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var pr = data && data.product; if (!pr || !pr.variants) return;
          var di = -1;
          (pr.options || []).forEach(function (o, i) { if (/design/i.test(o.name || '')) di = i; });
          if (di < 0) return;
          var born = {}, oldest = Infinity;
          pr.variants.forEach(function (v) {
            var t = Date.parse(v.created_at), dn = v['option' + (di + 1)];
            if (!isFinite(t) || !dn) return;
            if (t < oldest) oldest = t;
            if (born[dn] == null || t < born[dn]) born[dn] = t;
          });
          p.isNew = {};
          Object.keys(born).forEach(function (dn) {
            if (Date.now() - born[dn] < 45 * 864e5 && born[dn] - oldest > 7 * 864e5) p.isNew[fitName(p.designs, dn, dn)] = 1;
          });
          if (!Object.keys(p.isNew).length) return;
          var was = p.designs.slice();
          p.designs.sort(function (a, b) { return (p.isNew[b] ? 1 : 0) - (p.isNew[a] ? 1 : 0) || was.indexOf(a) - was.indexOf(b); });
          if (p.id === S.cur) renderDesigns();
        }).catch(function () {});
    });
  }

  /* ── Boot ────────────────────────────────────────────────────────────────── */
  function boot() {
    root = $('lid-root');
    var el = $('lid-data');
    if (!root || !el || root.__lidBooted) return;
    root.__lidBooted = true;
    var ds = el.dataset;
    GARM = json(ds.garments, {});
    var tiers = json(ds.tiers, []);
    TIERS = (Array.isArray(tiers) ? tiers : []).map(function (t) { return { min: int(t.min), prices: t.prices || {} }; })
      .filter(function (t) { return t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
    MIN = int(ds.minimum) || (TIERS[0] ? TIERS[0].min : 25);
    ZIP = num(ds.zip) || 7.7;
    data = { last: json(ds.lastOrder, null), turn: ds.turnaround || '', shop: ds.shopName || '' };
    var raws = json(ds.products, []).filter(Boolean);
    var seen = {};
    raws.forEach(function (r) { if (seen[r.id]) return; seen[r.id] = 1; var p = buildProduct(r); P.push(p); byId[p.id] = p; });
    if (!P.length) return;
    P.sort(function (a, b) { return (GORDER.indexOf(a.g) - GORDER.indexOf(b.g)) || byName(a.title, b.title); });
    S.cur = byId[ds.current] ? Number(ds.current) : P[0].id;
    DRAFT_KEY = 'lid_draft_' + (ds.collection || P[0].id);
    // Portal and search links carry ?design=NAME
    try {
      var want = new URLSearchParams(window.location.search).get('design');
      if (want) { var cp0 = byId[S.cur]; S.design[cp0.id] = fitName(cp0.designs, want, cp0.designs[0]); }
    } catch (x) {}
    var mq = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : { matches: true };
    S.desktop = mq.matches;
    if (mq.addEventListener) mq.addEventListener('change', function (m) { S.desktop = m.matches; renderAll(); });

    document.addEventListener('click', onClick);
    document.addEventListener('input', onInput);
    document.addEventListener('keydown', onKey);

    renderAll();
    loadNewDesigns();
    fetchCart().then(function (cart) {
      syncFromCart(cart, false);
      if (loadDraft()) { S.msg = 'Picked up where you left off.'; S.msgKind = ''; }
      renderAll();
    }).catch(function () { S.baseline = qSig(); renderAll(); });

    // Debug/test hook (used by the test page, harmless in production)
    window.__lidState = { S: S, P: P, propsFor: propsFor, tierAt: tierAt, parsePaste: parsePaste, state: state };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
